import { MERCHANT_TYPE } from '~/constants/restaurant'
import { defaultCurrency, paymentTypes } from '~/config/constant'
import { store } from '~/redux/store'
import { DEFAULT_FORMAT_PRICE } from '~/constants/currency'

export const getInfoRestaurant = () => {
  const infoRestaurant = {
    restaurantId: null,
    restaurantSlug: '', // restaurant slug
    restaurantName: '',
    tableId: null,
    tableUid: '',
    tableName: '',
    vatPercent: null,
    serviceRate: null,
    menuExcludesVAT: null,
    homeTemplateId: null,
    extraFeatures: [],
    logoTopPage: null,
    logoHomePage: null,
    line_page_url: '',
    supportLang: [],
    theme: 'default',
    externalPartner: '',
    currency: defaultCurrency,
    capichi_delivery_following: false,
    deeplink_store_on_delivery: '',
    merchant_type: MERCHANT_TYPE.RESTAURANT,
    paymentType: paymentTypes.pay_after_receive,
    food_court_id: null,
    food_court_slug: '',
    order_code: '',
    google_map_url: '',
    instagram_url: '',
    tripadvisor_url: '',
    timezone: '',
    banner_promote_delivery: [],
    separate_order: false,
    buffet_requests_time: [],
    linkage_requests_time: [],
    price_format: DEFAULT_FORMAT_PRICE,
    country: '',
  }

  const restaurantInfoLocal = store.getState().restaurant.data

  return restaurantInfoLocal || infoRestaurant
}

/**
 * Nếu trong trường hợp là menu điện tử thì sẽ ẩn nút: call staff, bill, pay,...
 * @returns boolean
 */
export const isElectronicMenu = () => {
  const { allow_order, merchant_type } = store.getState().restaurant?.data ?? {}

  return merchant_type === MERCHANT_TYPE.RESTAURANT && !allow_order
}
